import { Link } from 'react-router-dom';
import { useReveal } from '@/hooks/useReveal';
import { MisPromos }            from '@/components/home/MisPromos';
import { HistoriaSection }      from '@/components/home/HistoriaSection';
import { FeaturedProducts }     from '@/components/home/FeaturedProducts';
import { Testimonios }          from '@/components/home/Testimonios';
import { ContratacionesPreview } from '@/components/home/ContratacionesPreview';
import { InlineQuoteForm }      from '@/components/home/InlineQuoteForm';
import { ContactoSection }      from '@/components/home/ContactoSection';

export default function Home() {
  useReveal('home');

  return (
    <>
      {/* ═══ HERO ═══════════════════════════════════════════ */}
      <section id="inicio">
        <div className="hero-photo" />
        <div className="hero-grad" />
        <div className="hero-noise" />
        <div className="hero-body">
          <span className="hero-top">EMPACADORA · EST. 2016</span>
          <h1 className="hero-h1">LAS<br />POLVILLAS</h1>
          <div className="hero-div" />
          <p className="hero-tagline">PREMIUM QUALITY · CALIDAD GARANTIZADA</p>
          <Link to="/catalogo" className="btn">VER CATÁLOGO</Link>
        </div>
        <a className="hero-scroll" href="#historia">
          <span>SCROLL</span>
          <i className="fa-solid fa-chevron-down" />
        </a>
      </section>

      <MisPromos />
      <HistoriaSection />
      <FeaturedProducts />
      <Testimonios />
      <ContratacionesPreview />
      <InlineQuoteForm />
      <ContactoSection />
    </>
  );
}
